import type { SegmentSpec } from "./types";
import { DEFAULT_FLOOR_MATERIAL_ID } from "./FloorMaterials";

export const DEFAULT_ROOM_SURFACE_COLORS = {
  wall: 0xf2efe6,
  floor: 0xf0e0bc,
  ceiling: 0xd6d6d6,
  window: 0xffffff,
  door: 0xf2efe6,
} as const;

export interface RoomSurfaceColors {
  wall: number;
  floor: number;
  ceiling: number;
  window: number;
  door: number;
}

export const ROOM_SURFACE_KEYS = [
  "wall",
  "floor",
  "ceiling",
  "window",
  "door",
] as const satisfies readonly (keyof RoomSurfaceColors)[];

export { DEFAULT_FLOOR_MATERIAL_ID };

export interface PlanarGraphDocument {
  specs: SegmentSpec[];
  surfaces: RoomSurfaceColors;
  /** Curated floor finish id (see FloorMaterials). */
  floorMaterialId?: string;
}
